import { Injectable } from '@angular/core';
import { SocketService } from './socket.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment.prod';

@Injectable({
    providedIn: 'root'
})
export class InformacionService {
    url = environment.urlWhats;
    urlConsultaTexto = 'https://barbering.iatich.de/openai/api';

    constructor(
        public wsService: SocketService,
        private http: HttpClient
    ) { }

    getURL(idAdmin, id, role, token) {
        const headers = new HttpHeaders().set('rol-token', token);
        return this.http.get(`${this.url}/consultarRegistroIa/${idAdmin}/${id}/${role}`, { headers });
    }

    registrarURL(id, role, token, data) {
        const headers = new HttpHeaders().set('rol-token', token);
        // console.log('registrarURL desde el servicio', 'id:', id, 'role:', role, 'token:', token, 'data:', data);
        return this.http.post(`${this.url}/guardarRegistroIa/${id}/${role}`, data, { headers });
    }

    actualizarURL(idAdmin, id, role, token, data) {
        const headers = new HttpHeaders().set('rol-token', token);
        return this.http.put(`${this.url}/actualizarRegistroIa/${idAdmin}/${id}/${role}`, data, { headers });
    }

    realizarPregunta(data) {
        const headers = new HttpHeaders();
        return this.http.post(`${this.urlConsultaTexto}/consulta-pagina-clientes`, data, { headers });
    }

}
